import { get } from "../GenericServices";

const UserActiveDirectory = {
  getUserDataFromActiveDirectory: (username) => {
    return get(`user-active-directory/${username}`);
  },
};

export default UserActiveDirectory;
